export default __webpack_public_path__ + "/images/brush_palette.png";